import type { MessageSummary } from "@tabbio/types";

export function getUnreadMessageIdsForFocusedThread(params: {
  messages: readonly MessageSummary[];
  currentUserId: string;
  alreadyMarked: ReadonlySet<string>;
  isScreenFocused: boolean;
}): string[] {
  // Expo Router retains navigated-away screens in the stack. Mount state alone
  // therefore cannot prove that the user actually saw an incoming message.
  if (!params.isScreenFocused || !params.currentUserId) return [];

  return params.messages
    .filter(
      (message) =>
        message.senderId !== params.currentUserId &&
        !message.readBy.some(
          (receipt) => receipt.userId === params.currentUserId,
        ) &&
        !params.alreadyMarked.has(message.id),
    )
    .map((message) => message.id);
}
